import axios from 'axios';
var API = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL !== undefined ? process.env.VUE_APP_BACKEND_URL : 'http://localhost:3000',
    withCredentials: true
});
export var registerClient = function (data) {
    return API.post('/auth/register', data);
};
export var updateProfile = function (data) {
    return API.patch('/clients', data);
};
export var subscribe = function (data) {
    return API.post('/clients/subscribe', data);
};
export var subscription = function () {
    return API.get('/clients/subscriptions/current');
};
export var uploadVoucher = function (subID, formData) {
    return API.post('/clients/upload-voucher/' + subID, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export var getCredentials = function (body) {
    return API.post('/clients/subscriptions/credentials', body);
};
export var paypal = function (filter) {
    return API.post('/paypal/create', filter);
};
export var getCountries = function () {
    return API.get('/countries');
};
export var getGroupsFromOrders = function (filters) {
    return API.post('/clients/orders/groups', filters);
};
